import { render, staticRenderFns } from "./CartProperty.vue?vue&type=template&id=dc878690&scoped=true&"
import script from "./CartProperty.vue?vue&type=script&lang=js&"
export * from "./CartProperty.vue?vue&type=script&lang=js&"
import style0 from "./CartProperty.vue?vue&type=style&index=0&id=dc878690&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc878690",
  null
  
)

export default component.exports